type PendingNewPasswordChallenge = {
  email: string;
  user: any;
};

let pendingChallenge: PendingNewPasswordChallenge | null = null;

export const setPendingNewPasswordChallenge = ({
  email,
  user,
}: PendingNewPasswordChallenge): void => {
  pendingChallenge = {
    email: email.trim().toLowerCase(),
    user,
  };
};

export const getPendingNewPasswordChallenge =
  (): PendingNewPasswordChallenge | null => pendingChallenge;

export const hasPendingNewPasswordChallenge = (): boolean =>
  pendingChallenge !== null;

export const clearPendingNewPasswordChallenge = (): void => {
  pendingChallenge = null;
};
